import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  zone: Boundaries["removeZone"]["request"],
): State {
  return [...state, { zone, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  zone: Boundaries["removeZone"]["success"],
): State {
  return state.map((item) =>
    item.zone.uuid === zone.uuid
      ? { zone, request: setRequestStateToSuccess() }
      : item,
  );
}

function handleFailure(
  state: State,
  zone: Boundaries["removeZone"]["failure"],
): State {
  return state.map((item) =>
    item.zone.uuid === zone.uuid
      ? { zone, request: setRequestStateToFailure() }
      : item,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeZoneRequested]: handleRequest,
    [events.removeZoneSucceeded]: handleSuccess,
    [events.removeZoneFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
